import { Stack, ThemeProvider } from "@mui/material";
import { getTheme } from "@src/appV2/lib/Theme/theme";
import { ShiftBlockPage } from "@src/appV2/redesign/ShiftDiscovery/Blocks/Page";
import { getSafeAreaPaddings } from "@src/appV2/redesign/system/ui-theme";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useLocation, useParams } from "react-router-dom";

import { type OrientationShiftBlocksPageParams } from "./types";

export function OrientationShiftBlocksPage() {
  const worker = useDefinedWorker();
  const { facilityId } = useParams<OrientationShiftBlocksPageParams>();
  const location = useLocation();
  const qualification = new URLSearchParams(location.search).get("qualification") ?? undefined;

  return (
    <ThemeProvider theme={getTheme("light")}>
      <Stack
        sx={{
          ...getSafeAreaPaddings({ top: true }),
          flex: 1,
          minHeight: 0,
        }}
      >
        <ShiftBlockPage
          agent={worker}
          facilityId={facilityId}
          orientationBlockQualification={qualification}
        />
      </Stack>
    </ThemeProvider>
  );
}
